import React, { memo } from 'react';

import { useThemeGetter } from '@hooks';

import {
  ColoredLine,
  DCBGContainer,
  TransparentLine,
} from './DoubleColorBackground.styled';

import { DoubleColorBackgroundProps } from './DoubleColorBackground.types';

export const DoubleColorBackground = memo(
  ({ colorHeight }: DoubleColorBackgroundProps) => {
    const {
      theme: { BackgroundReverse },
    } = useThemeGetter();

    return (
      <DCBGContainer>
        <ColoredLine highlight={BackgroundReverse} colorHeight={colorHeight} />
        <TransparentLine />
      </DCBGContainer>
    );
  },
);
